import React from "react";
import "./LineBarExpense.scss";

const LineBarExpense = ({ dataholdings, datavalue }) => {
  // Data values from the example
  const holdingsValue = dataholdings;
  const statesValue = datavalue;
  const totalValue = holdingsValue + statesValue;

  // Calculate percentages for the bar segments
  const holdingsPercentage = (holdingsValue / totalValue) * 100;
  const statesPercentage = (statesValue / totalValue) * 100;

  // Format currency values
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(value);
  };

  return (
    <div className="comparative-container">
      <div className="header">
        <div className="frame-item-holding">
          {/* <div className="label holdings">BY HOLDINGS</div> */}
          <div className="amount holdings-amount">
            {formatCurrency(holdingsValue)}
          </div>
        </div>

        <div className="frame-item-state">
          <div className="amount states-amount">
            {formatCurrency(statesValue)}
          </div>
          {/* <div className="label states">BY STATES</div> */}
        </div>
      </div>

      <div className="bar">
        <div
          className="segment holdings"
          style={{ width: `${holdingsPercentage}%` }}
        >BY HOLDINGS</div>
        <div
          className="segment states"
          style={{ width: `${statesPercentage}%` }}
        >BY STATES</div>
      </div>
    </div>
  );
};

export default LineBarExpense;
